import { createFromIconfontCN } from '@ant-design/icons-vue'

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4095119_vrhddn366n8.js',
  extraCommonProps: {
    class: 'icon'
  }
})

export function installIcon2023 (app) {
  app.component('MyIcon2023', IconFont)
}
